import React from 'react';
import AppPage from '../../../@common/hoc/AppPage';
import asyncComponent from '../../../@common/utility/asyncComponent';

const User = asyncComponent(() => import('../../../modules/user'));
export default AppPage(() => <User />);
